export default {
  type: 'fyFinalMetrics',
  name: 'Final Fiscal Year User Metrics',
  permissions: {
    view: { app: 'metrics_dash', role: 'metrics_fy_users' },
    update: { app: 'metrics_dash', role: 'metrics_fy_users_final_update' }
  },
  newButton: false,
  search: {
    search: 'allFyFinalMetrics',
    orderBy: {
      type: 'FyFinalMetricsOrderBy',
      default: 'PROJECT_TITLE_ASC'
    },
    fields: [
      {
        name: 'fy',
        label: 'Fiscal Year',
        type: 'number',
        fieldType: 'Int',
        min: 2016,
        default: '$store.state.lastFiscalYear',
        export: false
      },
      {
        name: 'recordId',
        label: 'Record Number',
        showResults: false,
        searchable: false
      },
      {
        name: 'userFacility',
        showResults: false,
        searchable: false
      },
      {
        name: 'projectTitle',
        label: 'Project/Experiment Title',
        order: 'PROJECT_TITLE'
      },
      {
        name: 'projectType',
        label: 'Project/Experiment Type',
        showResults: false,
        searchable: false
      },
      {
        name: 'fundingSource',
        label: 'User Primary Source(s) of Project/Experiment Support',
        showResults: false,
        searchable: false
      },
      {
        name: 'lastName',
        label: 'User Last Name',
        showResults: false,
        searchable: false
      },
      {
        name: 'firstName',
        label: 'User First Name',
        showResults: false,
        searchable: false
      },
      {
        name: 'email',
        label: 'User Email'
      },
      {
        name: 'userType',
        showResults: false,
        searchable: false
      },
      {
        name: 'position',
        label: 'User Employment Level',
        showResults: false,
        searchable: false
      },
      {
        name: 'citizen',
        label: 'User is a U.S. Citizen',
        showResults: false,
        searchable: false
      },
      {
        name: 'citizenCountry',
        label: "User's Country of Citizenship",
        showResults: false,
        searchable: false
      },
      {
        name: 'affiliation',
        label: 'Home Institution Name',
        showResults: false,
        searchable: false
      },
      {
        name: 'smallBusiness',
        label: 'Home Institution is a Small Business',
        showResults: false,
        searchable: false
      },
      {
        name: 'address1',
        label: 'Home Institution Street Address',
        showResults: false,
        searchable: false
      },
      {
        name: 'city',
        label: 'Home Institution City',
        showResults: false,
        searchable: false
      },
      {
        name: 'state',
        label: 'Home Institution State / Province / Territory',
        showResults: false,
        searchable: false
      },
      {
        name: 'zipcode',
        label: 'Home Institution Zip Code',
        showResults: false,
        searchable: false
      },
      {
        name: 'country',
        label: 'Home Institution Country',
        showResults: false,
        searchable: false
      },
      {
        name: 'orcid',
        label: 'ORCID',
        showResults: false,
        searchable: false
      },
      // {
      //   name: 'covid',
      //   label: 'COVID - Related Project',
      //   showResults: false,
      //   searchable: false
      // },
      {
        name: 'projectDoi',
        label: 'Project/Experiment DOI',
        showResults: false,
        searchable: false
      }
    ]
  },
  save: {
    fields: [
      {
        field: 'fy',
        type: 'Int',
        required: true
      },
      {
        field: 'recordId',
        type: 'Int',
        required: true
      },
      'address1',
      'affiliation',
      'citizen',
      'citizenCountry',
      'city',
      'country',
      // 'covid',
      { field: 'email', required: true },
      'firstName',
      'fundingSource',
      'lastName',
      'orcid',
      'position',
      'projectDoi',
      'projectTitle',
      'projectType',
      'smallBusiness',
      'state',
      'typeOfBusiness',
      'userFacility',
      'userType',
      'zipcode'
    ],
    key: ['fy', 'recordId'],
    input: 'fyFinalMetrics',
    create: 'createFyFinalMetrics',
    delete: 'deleteFyFinalMetrics',
    update: 'updateFyFinalMetrics'
  },
  load: {
    nodeId: 'fyFinalMetrics',
    key: 'fyFinalMetricByFyAndRecordId'
  },
  form: {
    print: false,
    schema: [
      [
        {
          name: 'fy',
          label: 'Fiscal Year',
          width: 4
        },
        {
          name: 'userFacility',
          width: 4
        },
        {
          name: 'recordId',
          width: 4
        }
      ],
      [
        {
          name: 'projectTitle',
          width: 12
        }
      ],
      [
        {
          name: 'projectType',
          width: 4
        },
        {
          name: 'fundingSource',
          width: 8
        }
      ],
      [
        {
          name: 'firstName',
          width: 4
        },
        {
          name: 'lastName',
          width: 4
        },
        {
          name: 'email',
          width: 4
        }
      ],
      [
        {
          name: 'affiliation',
          width: 7
        },
        {
          name: 'position',
          label: 'User Employment Level',
          width: 5
        }
      ],
      [
        {
          name: 'userType',
          width: 2
        },
        {
          name: 'smallBusiness',
          width: 3
        },
        {
          name: 'typeOfBusiness',
          width: 7
        }
      ],
      [
        {
          name: 'address1',
          label: 'Address',
          width: 12
        }
      ],
      [
        {
          name: 'city',
          width: 3
        },
        {
          name: 'state',
          width: 2
        },
        {
          name: 'zipcode',
          label: 'Zip Code',
          width: 2
        },
        {
          name: 'country',
          width: 5
        }
      ],
      [
        {
          name: 'citizen',
          label: 'US Citizen',
          width: 2
        },
        {
          name: 'citizenCountry',
          label: 'Citizenship Country',
          width: 5
        },
        {
          name: 'orcid',
          label: 'ORCID',
          width: 5
        }
      ],
      [
        // {
        //   name: 'covid',
        //   label: 'Covid Related Project',
        //   width: 6
        // },
        {
          name: 'projectDoi',
          label: 'Project DOI',
          width: 6
        }
      ]
    ]
  }
}
